import { exclusiveType } from '../../types/components'
import { ExclusiveOfferDivWrapper, OfferSpan } from './style'

const ExclusiveOffers = ({ EXCLUSIVE_OFFER }: exclusiveType) => {
	return (
		<ExclusiveOfferDivWrapper>
			{EXCLUSIVE_OFFER.map((offer, index) => (
				<OfferSpan key={index}>{offer}</OfferSpan>
			))}
		</ExclusiveOfferDivWrapper>
	)
}

export default ExclusiveOffers
